import { useState, useRef } from 'react';
import ReactHtmlParser from 'html-react-parser';
import moment from 'moment';
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL } from "../../../env";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../../components/layouts/Layout";
import UserDetailReview from '../../../components/user-detail/UserDetailReview';
import { PDFExport } from "@progress/kendo-react-pdf";
import '@progress/kendo-theme-default/dist/all.css';
import { Table } from 'react-bootstrap';
import DailyData from '../common-options/daily-summary/DailyData';
import { addActivityLog } from '../../../helper/helper';


function ViewCarePlanHistory() {
    const storedUserDetails = localStorage.getItem("profileUserDetails");
    const userData = JSON.parse(storedUserDetails);

    const localStorageCarePlanHistory = localStorage.getItem("carePlanHistoryDetail");
    const carePlanHistoryDetail = JSON.parse(localStorageCarePlanHistory);

    const navigate = useNavigate();


    const viewCarePlanData = [
        { sectionTitle: "Involvement & Consent", sectionId: "involvementAndConsent", fieldValueContent: carePlanHistoryDetail?.involvementAndConsent },
        { sectionTitle: "One Page Profile", sectionId: "onePageProfile", fieldValueContent: carePlanHistoryDetail?.onePageProfile },
        { sectionTitle: "Information About Me", sectionId: "informationAboutMe", fieldValueContent: carePlanHistoryDetail?.informationAboutMe },
        { sectionTitle: "My Contacts", sectionId: "myContacts", fieldValueContent: carePlanHistoryDetail?.myContacts },
        { sectionTitle: "My Life History", sectionId: "myLifeHistory", fieldValueContent: carePlanHistoryDetail?.myLifeHistory },
        { sectionTitle: "My Dreams and Aspirations", sectionId: "myDreamsAndAspirations", fieldValueContent: carePlanHistoryDetail?.myDreamsAndAspirations },
        { sectionTitle: "My Goals and Outcomes", sectionId: "myGoalsAndOutcomes", fieldValueContent: carePlanHistoryDetail?.myGoalsAndOutcomes },
        { sectionTitle: "My Key Worker", sectionId: "myKeyWorker", fieldValueContent: carePlanHistoryDetail?.myKeyWorker },
        // { sectionTitle: "My Person Centred Support Plans", sectionId: "myPersonCentredSupportPlans", fieldValueContent: carePlanHistoryDetail?.myPersonCentredSupportPlans },
        { sectionTitle: "Communication", sectionId: "communication", fieldValueContent: carePlanHistoryDetail?.communication },
        { sectionTitle: "My Important People", sectionId: "myImportantPeople", fieldValueContent: carePlanHistoryDetail?.myImportantPeople },
        { sectionTitle: "My Likes and Dislikes", sectionId: "myLikesAndDislikes", fieldValueContent: carePlanHistoryDetail?.myLikesAndDislikes },
        { sectionTitle: "My Relationships", sectionId: "myRelationships", fieldValueContent: carePlanHistoryDetail?.myRelationships },
        { sectionTitle: "My Routines", sectionId: "myRoutines", fieldValueContent: carePlanHistoryDetail?.myRoutines },
        { sectionTitle: "My Sleeping", sectionId: "mySleeping", fieldValueContent: carePlanHistoryDetail?.mySleeping },
        { sectionTitle: "My Personal Care", sectionId: "myPersonalCare", fieldValueContent: carePlanHistoryDetail?.myPersonalCare },
        { sectionTitle: "My Weekly Budget", sectionId: "myWeeklyBudget", fieldValueContent: carePlanHistoryDetail?.myWeeklyBudget },
        { sectionTitle: "My Activities and Interests", sectionId: "myActivitiesAndInterests", fieldValueContent: carePlanHistoryDetail?.myActivitiesAndInterests },
        { sectionTitle: "My Activity Plan", sectionId: "myActivityPlan", fieldValueContent: carePlanHistoryDetail?.myActivityPlan },
        { sectionTitle: "My Perfect Week", sectionId: "myPerfectWeek", fieldValueContent: carePlanHistoryDetail?.myPerfectWeek },
        { sectionTitle: "Being Part of the Community", sectionId: "myBeingPartOfTheCommunity", fieldValueContent: carePlanHistoryDetail?.myBeingPartOfTheCommunity },
        { sectionTitle: "College, Career, Work Experience, Volunteering", sectionId: "myCollegeCareerWorkExperienceVolunteering", fieldValueContent: carePlanHistoryDetail?.myCollegeCareerWorkExperienceVolunteering },
        { sectionTitle: "My Daily Living Skills", sectionId: "myDailyLivingSkills", fieldValueContent: carePlanHistoryDetail?.myDailyLivingSkills },
        { sectionTitle: "My Mental Health", sectionId: "myMentalHealth", fieldValueContent: carePlanHistoryDetail?.myMentalHealth },
        { sectionTitle: "My Crisis Support", sectionId: "myCrisisSupport", fieldValueContent: carePlanHistoryDetail?.myCrisisSupport },
        { sectionTitle: "My Travelling", sectionId: "myTravelling", fieldValueContent: carePlanHistoryDetail?.myTravelling },
        { sectionTitle: "My Food and Drink", sectionId: "myFoodAndDrink", fieldValueContent: carePlanHistoryDetail?.myFoodAndDrink },
        { sectionTitle: "Support on Good and Bad Days", sectionId: "supportOnGoodBadDays", fieldValueContent: carePlanHistoryDetail?.supportOnGoodBadDays },
        { sectionTitle: "My Feelings and Behaviours", sectionId: "myFeelingsAndBehaviours", fieldValueContent: carePlanHistoryDetail?.myFeelingsAndBehaviours },
        { sectionTitle: "Keeping Safe and Well", sectionId: "keepingSafeAndWell", fieldValueContent: carePlanHistoryDetail?.keepingSafeAndWell },
        { sectionTitle: "Making My Own Decisions", sectionId: "makingMyownDecisions", fieldValueContent: carePlanHistoryDetail?.makingMyownDecisions },
        { sectionTitle: "My Health", sectionId: "myHealth", fieldValueContent: carePlanHistoryDetail?.myHealth },
        { sectionTitle: "My Medication", sectionId: "myMedication", fieldValueContent: carePlanHistoryDetail?.myMedication },
        { sectionTitle: "My Sexual Health", sectionId: "mySexualHealth", fieldValueContent: carePlanHistoryDetail?.mySexualHealth },
        { sectionTitle: "Religious, Spiritual, and Life Choices", sectionId: "religiousSpiritualAndLifeChoices", fieldValueContent: carePlanHistoryDetail?.religiousSpiritualAndLifeChoices },
        { sectionTitle: "My Finances", sectionId: "myFinances", fieldValueContent: carePlanHistoryDetail?.myFinances },
        { sectionTitle: "My Tenancy Information", sectionId: "myTenancyInformation", fieldValueContent: carePlanHistoryDetail?.myTenancyInformation },
        { sectionTitle: "My Reviews", sectionId: "myReviews", fieldValueContent: carePlanHistoryDetail?.myReviews },
        { sectionTitle: "My Health Action Plan", sectionId: "myHealthActionPlan", fieldValueContent: carePlanHistoryDetail?.myHealthActionPlan },
        { sectionTitle: "Risk Assessments", sectionId: "riskAssessments", fieldValueContent: "" },
        { sectionTitle: "PEEP", sectionId: "PEEP", fieldValueContent: carePlanHistoryDetail?.PEEP },
        { sectionTitle: "Missing Persons Profile", sectionId: "missingPersonsProfile", fieldValueContent: carePlanHistoryDetail?.missingPersonsProfile },
        { sectionTitle: "Personal Inventory", sectionId: "personalInventory", fieldValueContent: carePlanHistoryDetail?.personalInventory },
        { sectionTitle: "After My Death", sectionId: "afterMyDeath", fieldValueContent: carePlanHistoryDetail?.afterMyDeath },
        // { sectionTitle: "Recording File", sectionId: "recordingFile", fieldValueContent: carePlanHistoryDetail?.recordingFile },
        { sectionTitle: "Daily Diary", sectionId: "dailyDiary", fieldValueContent: "" },
        { sectionTitle: "My Key Worker Key Work Meetings", sectionId: "myKeyWorkerKeyWorkMeetings", fieldValueContent: carePlanHistoryDetail?.myKeyWorkerKeyWorkMeetings },
        { sectionTitle: "MCA Best Interests Decisions DoLS", sectionId: "MCABestInterestsDecisionsDoLS", fieldValueContent: "" },
        { sectionTitle: "ABC Charts", sectionId: "aBCCharts", fieldValueContent: "" },
        { sectionTitle: "Health Appointment Records", sectionId: "healthAppointmentRecords", fieldValueContent: "" },
        // { sectionTitle: "Menstruation", sectionId: "menstruation", fieldValueContent: carePlanHistoryDetail?.menstruation },
        { sectionTitle: "Weight Records", sectionId: "weightRecords", fieldValueContent: "" },
        { sectionTitle: "Seizure Records", sectionId: "seizureRecords", fieldValueContent: carePlanHistoryDetail?.seizureRecords },
        { sectionTitle: "Financial Records", sectionId: "financialRecords", fieldValueContent: carePlanHistoryDetail?.financialRecords },
    ]

    const pdfExportComponent = useRef(null);
    const [showInPrint, setShowInPrint] = useState(false);
    const exportPDF = () => {
        if (pdfExportComponent.current) {
            setShowInPrint(true);
            setTimeout(() => {
                pdfExportComponent.current.save();
            }, 100);
            setTimeout(() => {
                setShowInPrint(false);
            }, 1000);
        }
        addActivityLog({
            message: "Download in PDF",
            module: "Care Plan History",
        })

    };

    return (
        <>
            <Layout
                pageTitleText={
                    <>
                        Care Plan History
                    </>
                }
            >
                <UserDetailReview
                    getUserRecord={userData}
                    avatarActionButtons={false}
                    viewNotes={false}
                    profileDetail={false}
                    horizontalDetail={true}
                    launchVideoButtons={true}
                />
                <div className="viewEditorWrapper">
                    <div className="mainContent mt-3 pt-4">

                        <>
                            <header className="mainContentHeader pt-0 pb-4">
                                <span>&nbsp;</span>
                                <div>
                                    <div className="actionColumns">
                                        <span className="btn btn-sm btn-outline-primary"
                                            onClick={exportPDF}
                                        >Export to PDF</span>

                                        <span className="btn btn-sm btn-primary" onClick={() => {
                                            navigate("/care-plans");
                                        }}>Back to Care Plan Summary</span>

                                    </div>

                                </div>
                            </header>
                            <PDFExport
                                ref={pdfExportComponent}
                                paperSize={["900pt", "900pt"]}
                                margin={20}
                                fileName={`Daily Care Plan`}
                            >
                                <div className="viewEditorContent">
                                    <header className='createAndModifyStatus'>
                                        <div className="enteredBy">
                                            <span className="usersNameInfo">
                                                <span className="userImage">
                                                    <img src={`${BASE_URL}${carePlanHistoryDetail?.addedby?.profile_picture_url}`} alt={carePlanHistoryDetail?.addedby?.name} />
                                                </span>
                                                <span className="userInfo">
                                                    {/* <h1 className="no-print">This will be excluded from the PDF</h1> */}
                                                    <span><small>Created by: updated</small></span>
                                                    <strong >{carePlanHistoryDetail?.addedby?.name}</strong>
                                                    <span><small>{moment(carePlanHistoryDetail?.createdAt).format("DD/MM/YYYY / hh:mm:ss A")}</small></span>
                                                </span>
                                            </span>
                                        </div>
                                        {
                                            <>
                                                <div className="enteredBy">
                                                    <span className="usersNameInfo">
                                                        <span className="userImage">
                                                            <img src={`${BASE_URL}${carePlanHistoryDetail?.modifiedUser?.profile_picture_url}`} alt={carePlanHistoryDetail?.modifiedUser?.name} />
                                                        </span>
                                                        <span className="userInfo">
                                                            <span><small>Modified by:</small></span>
                                                            <strong >{carePlanHistoryDetail?.modifiedUser?.name}</strong>
                                                            <span><small>{moment(carePlanHistoryDetail?.modifiedTime).format("DD/MM/YYYY / hh:mm:ss A")}</small> </span>
                                                        </span>
                                                    </span>
                                                </div>
                                            </>
                                        }

                                    </header>
                                    {
                                        viewCarePlanData?.map((item, index) => (
                                            <>
                                                <div className="sectionWrapper">
                                                    <div className="sectionContent pbsFieldWrapper">
                                                        <header className="alert alert-dark">
                                                            <h3 className='viewCarePlanTitle'>
                                                                {item?.sectionTitle}
                                                                {
                                                                    item?.sectionId === "riskAssessments" ? (
                                                                        <>
                                                                            <span className={
                                                                                showInPrint ? ("hiddenDiv") : ("")
                                                                            }>
                                                                                <Link to="/risk-assessments" className="btn btn-sm btn-primary">Clicke here to view</Link>
                                                                            </span>
                                                                        </>
                                                                    ) : item?.sectionId === "aBCCharts" ? (
                                                                        <>
                                                                            <span className={
                                                                                showInPrint ? ("hiddenDiv") : ("")
                                                                            }>
                                                                                <Link to="/care-plan/abc" className="btn btn-sm btn-primary">Clicke here to view</Link>
                                                                            </span>
                                                                        </>
                                                                    ) : item?.sectionId === "MCABestInterestsDecisionsDoLS" ? (
                                                                        <>
                                                                            <span className={
                                                                                showInPrint ? ("hiddenDiv") : ("")
                                                                            }>
                                                                                <Link to="/care-plan/consent-capacity-mca-dols" className="btn btn-sm btn-primary">Clicke here to view</Link>
                                                                            </span>
                                                                        </>
                                                                    ) : item?.sectionId === "healthAppointmentRecords" ? (
                                                                        <>
                                                                            <span className={
                                                                                showInPrint ? ("hiddenDiv") : ("")
                                                                            }>
                                                                                <Link to="/care-plan/health-appointments" className="btn btn-sm btn-primary">Clicke here to view</Link>
                                                                            </span>
                                                                        </>
                                                                    ) : item?.sectionId === "weightRecords" ? (
                                                                        <>
                                                                            <span className={
                                                                                showInPrint ? ("hiddenDiv") : ("")
                                                                            }>
                                                                                <Link to="/care-plan/weight-height" className="btn btn-sm btn-primary">Clicke here to view</Link>
                                                                            </span>
                                                                        </>
                                                                    ) : item?.sectionId === "dailyDiary" ? (
                                                                        <>
                                                                            <span className={
                                                                                showInPrint ? ("hiddenDiv") : ("")
                                                                            }>
                                                                                <Link to="/care-plan/daily-summary" className="btn btn-sm btn-primary">Clicke here to view</Link>
                                                                            </span>
                                                                        </>
                                                                    ) : (
                                                                        <div className='actionButtons'>

                                                                        </div>
                                                                    )
                                                                }

                                                            </h3>
                                                        </header>
                                                        {
                                                            (item?.sectionId !== "riskAssessments" &&
                                                                item?.sectionId !== "aBCCharts" &&
                                                                item?.sectionId !== "MCABestInterestsDecisionsDoLS" &&
                                                                item?.sectionId !== "healthAppointmentRecords" &&
                                                                item?.sectionId !== "weightRecords" &&
                                                                item?.sectionId !== "dailyDiary" &&
                                                                item?.sectionId !== "myContacts") &&
                                                            (
                                                                <div className="p-3">
                                                                    {ReactHtmlParser(item?.fieldValueContent)}
                                                                </div>
                                                            )
                                                        }
                                                        {
                                                            item?.sectionId === "dailyDiary" && (

                                                                // showInPrint && (
                                                                <>
                                                                    <div className={
                                                                        showInPrint ? ("displayDiv") : ("hiddenDiv")
                                                                    }>
                                                                        <DailyData titleandButton={false} dailySummaryDate={false} />
                                                                    </div>

                                                                </>

                                                            )
                                                        }


                                                        {
                                                            item?.sectionId === "myContacts" && (
                                                                carePlanHistoryDetail?.myContacts.length > 0 && (
                                                                    <>
                                                                        <div className="table-responsive">
                                                                            <Table striped bordered hover className='myContactsViewCarePlan'>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>Sr No.</th>
                                                                                        <th>Name</th>
                                                                                        <th>Relationship</th>
                                                                                        <th>Email</th>
                                                                                        <th>Phone Number</th>
                                                                                        <th>Address</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {
                                                                                        carePlanHistoryDetail?.myContacts?.map((item, index) => (
                                                                                            <>
                                                                                                <tr>
                                                                                                    <td><p>{index + 1}</p></td>
                                                                                                    <td><p>{item?.name}</p></td>
                                                                                                    <td><p>{item?.relationship}</p></td>
                                                                                                    <td><p>{item?.email}</p></td>
                                                                                                    <td><p>{item?.phoneNumber}</p></td>
                                                                                                    <td><p>{item?.address}</p></td>
                                                                                                </tr>
                                                                                            </>
                                                                                        ))
                                                                                    }
                                                                                </tbody>
                                                                            </Table>
                                                                        </div>
                                                                    </>
                                                                )
                                                            )
                                                        }
                                                    </div>
                                                </div >
                                            </>
                                        ))
                                    }
                                </div>
                            </PDFExport>
                        </>
                    </div>
                </div>
            </Layout >

        </>
    );
}

export default ViewCarePlanHistory